import { render, staticRenderFns } from "./DataMigrationWindow.vue?vue&type=template&id=446914c7&scoped=true"
import script from "./DataMigrationWindow.vue?vue&type=script&lang=js"
export * from "./DataMigrationWindow.vue?vue&type=script&lang=js"
import style0 from "./DataMigrationWindow.vue?vue&type=style&index=0&id=446914c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446914c7",
  null
  
)

export default component.exports